<template>
  <!-- 教學頁的評價牆（2026-10-16，哲宇 16:11：「這個 session 也加入學生評價這個模組跟內容」；參考課程網站首頁的 ReviewWall，
       長相照官網自己的設計系統：無框、--bg1 圓角卡、金色星）。三排慢速橫移，中間那排反向；同一排畫兩份、整條平移一半，接縫看不見，
       第二份只給眼睛看（aria-hidden）。滑過或聚焦哪一排就停那一排，整塊捲出畫面也停。減少動態：不動，改成可以自己橫向捲，只留第一份。
       評價是 Hahow 上的中文原文，英文頁照原文放（lang="zh-Hant"），課名換英文。 -->
  <div ref="wall" class="trw" :class="{ 'is-on': on }">
    <div v-for="(row, r) in rows" :key="r" class="trw-row">
      <ul class="trw-track" :class="{ 'is-rev': r % 2 === 1 }" :style="{ '--trw-dur': row.length * SEC[r] + 's' }">
        <template v-for="copy in [0, 1]" :key="copy">
          <li v-for="v in row" :key="copy + '-' + v.id" class="trw-card" :aria-hidden="copy ? 'true' : null">
            <span class="trw-stars" role="img" :aria-label="starsLabel(v.rating)">{{ '★'.repeat(v.rating) }}</span>
            <b v-if="v.title" class="trw-title" lang="zh-Hant">{{ v.title }}</b>
            <blockquote lang="zh-Hant">{{ v.text }}</blockquote>
            <span class="trw-who"><b>{{ v.name }}</b>{{ courseName(v.course) }}・{{ v.year }}</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import wallData from '@/data/teaching-reviews.json'

const props = defineProps({
  lang: { type: String, default: 'zh' },
  // 課程代號 → { zh, en } 課名（從 teaching.json 的 courses 帶進來，不在這裡另寫一份）
  names: { type: Object, required: true },
})

// 每張卡走過的秒數（卡寬加間距約 376px，約每秒 20px），三排各不同，整面牆才不會一起平移
const SEC = [16, 19, 17.5]
const rows = SEC.map((_, r) => wallData.reviews.filter((_, i) => i % SEC.length === r))
const courseName = (slug) => props.names[slug]?.[props.lang] || slug
const starsLabel = (n) => (props.lang === 'zh' ? `${n} 顆星` : `${n} stars`)

const wall = ref(null), on = ref(false)
let io = null
onMounted(() => {
  if (!wall.value || typeof IntersectionObserver !== 'function') { on.value = true; return }
  io = new IntersectionObserver(([e]) => { on.value = e.isIntersecting }, { rootMargin: '200px 0px' })
  io.observe(wall.value)
})
onBeforeUnmount(() => io?.disconnect())
</script>

<style>
/* 滿版（突破 editorial 寬度），左右各留一段漸層淡出 */
.trw { display: grid; gap: 14px; margin-inline: calc(50% - 50vw); -webkit-mask-image: linear-gradient(90deg, transparent, #000 7%, #000 93%, transparent); mask-image: linear-gradient(90deg, transparent, #000 7%, #000 93%, transparent); }
.trw-row { overflow: hidden; }
.trw-track { display: flex; align-items: stretch; width: max-content; margin: 0; padding: 0; list-style: none; animation: trw-move var(--trw-dur, 600s) linear infinite; animation-play-state: paused; will-change: transform; }
.trw-track.is-rev { animation-direction: reverse; }
.trw.is-on .trw-track { animation-play-state: running; }
.trw-row:hover .trw-track, .trw-row:focus-within .trw-track { animation-play-state: paused; }
@keyframes trw-move { from { transform: translateX(0) } to { transform: translateX(-50%) } }
.trw-card { flex: 0 0 auto; width: 360px; margin: 0 14px 0 0; display: flex; flex-direction: column; gap: 8px; padding: 20px 22px 18px; border-radius: var(--r-lg, 18px); background: var(--bg1); }
.trw-stars { color: var(--gold); letter-spacing: 0.16em; font-size: 13px; line-height: 1.2; }
.trw-title { font-family: var(--font-display); font-weight: 400; font-size: 16px; line-height: 1.5; color: var(--ink); }
.trw-card blockquote { margin: 0; padding: 0; border: 0; font-size: 14px; line-height: 1.8; color: var(--ink-2); }
.trw-who { margin-top: auto; padding-top: 8px; font-size: 12.5px; color: var(--ink-3); }
.trw-who b { font-weight: 500; color: var(--ink-2); margin-right: 8px; }
@media (max-width: 640px) {
  .trw { -webkit-mask-image: linear-gradient(90deg, transparent, #000 4%, #000 96%, transparent); mask-image: linear-gradient(90deg, transparent, #000 4%, #000 96%, transparent); }
  .trw-card { width: 300px; padding: 16px 18px; }
  .trw-card blockquote { font-size: 13.5px; }
}
@media (prefers-reduced-motion: reduce) {
  .trw-track { animation: none; }
  .trw-row { overflow-x: auto; scrollbar-width: none; padding-inline: max(16px, calc((100vw - var(--editorial-w, 1560px)) / 2)); }
  .trw-row::-webkit-scrollbar { display: none; }
  .trw-card[aria-hidden="true"] { display: none; }
}
</style>
